// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import TotalSummaryMetrics from './TotalSummaryMetrics';
import Proposition from '../../proposition/domain/proposition';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.metrics.margin}px;
`;

type Props = {
  proposition: Proposition,
  theme: any,
  t: any,
};

function CombinedSummaryMetrics(props: Props) {
  const {
    theme, t, proposition,
  } = props;
  const titleStyle = {
    ...theme.fonts.style.smallCardTitle,
    paddingTop: theme.metrics.margin,
  };

  return (
    <Container>
      <h2 style={titleStyle}>{t('totalSummary')}</h2>
      <TotalSummaryMetrics proposition={proposition} />
    </Container>
  );
}

export default translate('commonSales')(withTheme(CombinedSummaryMetrics));



// WEBPACK FOOTER //
// ./src/common/modules/sales/components/CombinedSummaryMetrics.js